(() => {
  const activateDealer = (section, targetIndex) => {
    section.querySelectorAll('[data-dealer-trigger]').forEach((trigger) => {
      const isActive = trigger.dataset.dealerTrigger === String(targetIndex);
      trigger.classList.toggle('is-active', isActive);
      trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    section.querySelectorAll('[data-dealer-panel]').forEach((panel) => {
      const isActive = panel.dataset.dealerPanel === String(targetIndex);
      panel.hidden = !isActive;
      panel.classList.toggle('is-active', isActive);
    });
  };

  const initialise = (section) => {
    if (!section || section.dataset.locationsReady === 'true') return;
    section.dataset.locationsReady = 'true';

    section.querySelectorAll('[data-dealer-trigger]').forEach((trigger) => {
      const activate = () => activateDealer(section, trigger.dataset.dealerTrigger);
      trigger.addEventListener('pointerenter', activate);
      trigger.addEventListener('focus', activate);
      trigger.addEventListener('click', activate);
    });

    if (!('IntersectionObserver' in window)) {
      section.classList.add('is-visible');
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -7% 0px' });

    observer.observe(section);
  };

  const initialiseAll = (root = document) => {
    root.querySelectorAll('[data-sampa-locations]').forEach(initialise);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll());
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
